import { render, staticRenderFns } from "./SimModalNuevo.vue?vue&type=template&id=f1607016&scoped=true&"
import script from "./SimModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./SimModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./SimModalNuevo.vue?vue&type=style&index=0&id=f1607016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1607016",
  null
  
)

export default component.exports